import { useEvidenceAnalytics } from '@/hooks/useEvidenceAnalytics';
import { useBaseChatHref, useResetProjectsComposerContext } from '@heidi/agents/data';
import { Button } from '@heidi/design-system/button';
import { useTranslations } from '@heidi/runtime/i18n';
import { SquarePen } from 'lucide-react';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

/**
 * New Chat action button for the desktop evidence panel header. Routes to the
 * flag-aware base chat home so it matches the chat sidebar + "Work" nav.
 */
export function EvidencePanelAction() {
  const { t } = useTranslations();
  const router = useRouter();
  const { trackNewChatClicked } = useEvidenceAnalytics();
  const baseChatHref = useBaseChatHref();
  const resetProjectsComposerContext = useResetProjectsComposerContext();

  const handleNewChatClick = useCallback(() => {
    trackNewChatClicked('sidebar');
    resetProjectsComposerContext();
    void router.push(baseChatHref, undefined, { shallow: true });
  }, [router, trackNewChatClicked, baseChatHref, resetProjectsComposerContext]);

  return (
    <Button variant="secondary" size="sm" onClick={handleNewChatClick}>
      <SquarePen />
      {t('chat.newChat')}
    </Button>
  );
}
